import { useParams } from 'react-router-dom'

export const getQueryConfig = () => {
  const { token } = useParams()
  return { headers: { sessionauthorization: token } }
}
